<template>
  <div id="BillingReadingforPeriodReport">
    <div :class="`loader${loaderClass}`" v-show="loading"></div>

    <div id="page-content-wrapper" class="admin-content-area" >
       <template v-if="cantAccessPage === true">
          <div class="page-name">
            <div class="page-title">Billing Readings For Period</div>
            <div class="web-action-btn btn-groups text-right">
              <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="exportReports()">
                  <i class="fp-export"></i> Export
              </a>
          </div>
          </div>
          <div class="container-fluid">
            <div class="admin-page-content contact-list">
               <data-table-filter-config :moduleName="'BillingReadingforPeriodReport'" ref="filterComponent" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
                <div class="data-table bg-white overflow-hidden">
                  <p v-if="batchProcess" class="alert-success p-2" id="processFetchBatchMsg">Export file is in process. batch no. is {{batchNum}}. <router-link class="color-blue" v-bind:to="{name: 'BatchList'}" target="_blank" @click.native="batchProcess = 0"> Click Here</router-link> to check file status!</p>
                  <section class="bg-white data-table">
                      <custom-pagination
                          :page-changed="onPageChange"
                          :per-page-changed="onPerPageChange" :moduleName="'BillingReadingforPeriodReport'" :position="'top'">
                      </custom-pagination>

                      <vue-good-table
                          ref="billingReadingTable"
                          mode="remote"
                          title="Billing Reading For Period"
                          @on-page-change="onPageChange"
                          @on-sort-change="onSortChange"
                          @on-column-filter="onColumnFilter"
                          @on-per-page-change="onPerPageChange"
                          :totalRows="totalRecords"
                          :columns="userColumns"
                          :rows="rows"
                          :isLoading=false
                          :paginationOptions="{
                              enabled: false,
                              position: 'both',
                              perPage: perPage,
                              dropdownAllowAll: false,
                              setCurrentPage:listCurrentPage,
                              perPageDropdown:dropDownPerPage,
                          }"
                          :search-options="{
                          enabled: false,
                          }"
                          :sort-options="{
                          enabled: true,
                          }">
                      </vue-good-table>
                      <custom-pagination
                          :page-changed="onPageChange"
                          :per-page-changed="onPerPageChange">
                      </custom-pagination>
                  </section>
                </div>

            </div>
          </div>
       </template>
       <template v-else-if="cantAccessPage === false">
          <div class="container-fluid">
              <div class="bg-white text-center">
                  <h1>
                      Oops!</h1>
                  <h2>
                      403 </h2>
                  <div class="error-details">
                      Sorry!, You don't have permission to access this page.
                  </div>
              </div>
          </div>
      </template>
      <template v-else>
          <loading-content></loading-content>
      </template>
      <app-footer></app-footer>
    </div>
  </div>
</template>
<script>

import Vue from "vue";
 import {commonMixins} from '../../mixins/commonMixins';
 import {dataTableMixins} from '../../mixins/dataTableMixins';

export default {
  name: "BillingReadingForPeriodReport",
  mixins: [commonMixins,dataTableMixins],
  data: () => ({
      cantAccessPage:"",
      loading: false,
      pageTitle:'Billing Reading For Period',
      permissions:[],
      rows: [],
      totalRecords: 0,
      userColumns:[],
      columns:[
        {
            label: "Unit Number",
            field: "unit_no",
            filterable: true,
            fpFieldType:"text",
            hidden:false,
            width: '90px',
            filterOptions: {
            enabled: false, // enable filter for this column
            placeholder: "#Unit", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            filterFn: this.onColumnFilter, //custom filter function that
            trigger: "enter" //only trigger on enter not on keyup
            }
        },
        {
            label: "Reading Date",
            field: "reading_date",
            filterable: true,
            fpFieldType:"date",
            hidden:false,
            filterOptions: {
            enabled: false, // enable filter for this column
            placeholder: "MM/DD/YYYY", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            filterFn: this.onColumnFilter, //custom filter function that
            trigger: "enter" //only trigger on enter not on keyup
            }
        },
        {
            label: "Reading",
            field: "reading",
            filterable: true,
            fpFieldType:"integer",
            type: 'number',
            hidden:false,
            filterOptions: {
            enabled: false, // enable filter for this column
            placeholder: "reading", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            filterFn: this.onColumnFilter, //custom filter function that
            trigger: "enter" //only trigger on enter not on keyup
            }
        },

        {
            label: "Reading Type",
            field: "reading_type",
            fpFieldType:"text",
            filterable: false,
            hidden:false,
            filterOptions: {
            enabled: false, // enable filter for this column
            placeholder: "Reading Type", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            filterFn: this.onColumnFilter, //custom filter function that
            trigger: "enter" //only trigger on enter not on keyup
            },
            sortable:false
        },
        {
            label: "Actual Or Estimate",
            field: "actual_estimate",
            fpFieldType:"option",
            filterable: true,
            hidden:false,
            filterOptions: {
            enabled: false, // enable filter for this column
            placeholder: "estimate", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: ['A','E'], // dropdown (with selected values) instead of text input
            filterFn: this.onColumnFilter, //custom filter function that
            trigger: "enter" //only trigger on enter not on keyup
            }
        },
        {
            label: "Billed",
            field: "billed",
            fpFieldType:"option",
            filterable: true,
            hidden:false,
            filterOptions: {
            enabled: false, // enable filter for this column
            placeholder: "#Cust", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: ['B','I'], // dropdown (with selected values) instead of text input
            filterFn: this.onColumnFilter, //custom filter function that
            trigger: "enter" //only trigger on enter not on keyup
            },
            // sortable:false
        },
        {
            label: "Reading LTD",
            field: "ltd_reading",
            fpFieldType:"integer",
            type:'number',
            filterable: true,
            hidden:false,
            filterOptions: {
            enabled: false, // enable filter for this column
            placeholder: "LTD Reading", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            filterFn: this.onColumnFilter, //custom filter function that
            trigger: "enter" //only trigger on enter not on keyup
            },
        },
        {
            label: "Meter Change",
            field: "meter_change",
            filterable: true,
            fpFieldType:"option",
            hidden:false,
            filterOptions: {
                enabled: false, // enable filter for this column
                placeholder: "meter change", // placeholder for filter input
                filterValue: '', // initial populated value for this filter
                filterDropdownItems: ['Yes','No'], // dropdown (with selected values) instead of text input
                filterFn: this.onColumnFilter, //custom filter function that
                trigger: "enter" //only trigger on enter not on keyup
            }

        },
        {
            label: "Metric Type",
            field: "section",
            filterable: true,
            fpFieldType:"option",
            hidden:false,
            filterOptions: {
                enabled: false, // enable filter for this column
                placeholder: "metric type", // placeholder for filter input
                filterValue: '', // initial populated value for this filter
                filterDropdownItems: [], // dropdown (with selected values) instead of text input
                filterFn: this.onColumnFilter, //custom filter function that
                trigger: "enter" //only trigger on enter not on keyup
            }

        },
        {
            label: "Agreement Header Type",
            field: "agreement_type",
            filterable: true,
            fpFieldType:"option",
            hidden:false,
            filterOptions: {
            enabled: false, // enable filter for this column
            placeholder: "status", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: ['RC','LC'], // dropdown (with selected values) instead of text input
            filterFn: this.onColumnFilter, //custom filter function that
            trigger: "enter" //only trigger on enter not on keyup
            },
            sortable:false
        },
        {
            label: "Agreement Number",
            field: "agreement_no",
            fpFieldType:"text",
            filterable: true,
            hidden:false,
            filterOptions: {
            enabled: false, // enable filter for this column
            placeholder: "Agreement", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            filterFn: this.onColumnFilter, //custom filter function that
            trigger: "enter" //only trigger on enter not on keyup
            },
        },
        {
            label: "Unit Assignment Date ISO",
            field: "unit_assignement_date",
            filterable: true,
            fpFieldType:"date",
            hidden:false,
            filterOptions: {
            enabled: false, // enable filter for this column
            placeholder: "Unit Assignment Date ISO", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            filterFn: this.onColumnFilter, //custom filter function that
            trigger: "enter" //only trigger on enter not on keyup
            }
        },
        {
            label: "Facility ID Code",
            field: "assigned_facility",
            filterable: true,
            fpFieldType:"option",
            hidden:false,
            filterOptions: {
            enabled: false, // enable filter for this column
            placeholder: "po", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            filterFn: this.onColumnFilter, //custom filter function that
            trigger: "enter" //only trigger on enter not on keyup
            }
        },
        {
            label: "Destination Facility",
            field: "destined_facility",
            filterable: false,
            fpFieldType:"text",
            hidden:false,
            filterOptions: {
            enabled: false, // enable filter for this column
            placeholder: "Destination Facility", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            filterFn: this.onColumnFilter, //custom filter function that
            trigger: "enter" //only trigger on enter not on keyup
            },
            sortable: false,
        },
        {
            label: "Customer Company Code",
            field: "company_code",
            filterable: true,
            fpFieldType:"option",
            hidden:false,
            filterOptions: {
            enabled: false, // enable filter for this column
            placeholder: "#company", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems : ['000', '001', '002'], //dropdown (with selected values) instead of text input
            trigger: "enter" //only trigger on enter not on keyup
            }
        },
        {
            label: "Customer Number",
            field: "customer_number",
            filterable: true,
            fpFieldType:"text",
            hidden:false,
            filterOptions: {
            enabled: false, // enable filter for this column
            placeholder: "#Customer Number", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            filterFn: this.onColumnFilter, //custom filter function that
            trigger: "enter" //only trigger on enter not on keyup
            }
        },
        {
            label: "Customer Suffix",
            field: "customer_suffix",
            filterable: true,
            fpFieldType:"text",
            hidden:false,
            filterOptions: {
            enabled: false, // enable filter for this column
            placeholder: "#Customer Suffix", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            filterFn: this.onColumnFilter, //custom filter function that
            trigger: "enter" //only trigger on enter not on keyup
            }
        },
        {
            label: "Customer Name",
            field: "customer_name",
            filterable: true,
            fpFieldType:"text",
            hidden:false,
            filterOptions: {
            enabled: false, // enable filter for this column
            placeholder: "#Customer Name", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            filterFn: this.onColumnFilter, //custom filter function that
            trigger: "enter" //only trigger on enter not on keyup
            }
        },
        {
            label: "Contract Equip Sts",
            field: "reservation_status",
            filterable: true,
            fpFieldType:"option",
            hidden:false,
            filterOptions: {
            enabled: false, // enable filter for this column
            placeholder: "#Status", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            filterFn: this.onColumnFilter, //custom filter function that
            trigger: "enter" //only trigger on enter not on keyup
            }
        },
         {
            label: "Prior Reading",
            field: "prev_reading",
            fpFieldType:"integer",
            type: 'number',
            filterable: true,
            hidden:false,
            filterOptions: {
            enabled: false, // enable filter for this column
            placeholder: "reading", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            filterFn: this.onColumnFilter, //custom filter function that
            trigger: "enter" //only trigger on enter not on keyup
            }
        },
        {
            label: "Prior Reading Date",
            field: "prev_reading_date",
            filterable: true,
            fpFieldType:"date",
            hidden:false,
            filterOptions: {
            enabled: false, // enable filter for this column
            placeholder: "MM/DD/YYYY", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            filterFn: this.onColumnFilter, //custom filter function that
            trigger: "enter" //only trigger on enter not on keyup
            }
        },
       {
            label: "Prior Actual Or Estimate",
            field: "prev_is_accurate",
            fpFieldType:"option",
            filterable: true,
            hidden:false,
            filterOptions: {
            enabled: false, // enable filter for this column
            placeholder: "estimate", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: ['Yes','No'], // dropdown (with selected values) instead of text input
            filterFn: this.onColumnFilter, //custom filter function that
            trigger: "enter" //only trigger on enter not on keyup
            }
        },
        {
            label: "Variance",
            field: "variance",
            fpFieldType:"integer",
            type: 'number',
            filterable: true,
            hidden:false,
            filterOptions: {
            enabled: false, // enable filter for this column
            placeholder: "variance", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            filterFn: this.onColumnFilter, //custom filter function that
            trigger: "enter" //only trigger on enter not on keyup
            }
        },
        {
            label: "Change Description",
            field: "description",
            fpFieldType:"text",
            filterable: true,
            hidden:false,
            filterOptions: {
            enabled: false, // enable filter for this column
            placeholder: "description", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            filterFn: this.onColumnFilter, //custom filter function that
            trigger: "enter" //only trigger on enter not on keyup
            },
            // sortable:false
        },
        {
            label: "Days Since Last Reading",
            field: "days",
            fpFieldType:"integer",
            type: 'number',
            filterable: true,
            hidden:false,
            filterOptions: {
            enabled: false, // enable filter for this column
            placeholder: "description", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            filterFn: this.onColumnFilter, //custom filter function that
            trigger: "enter" //only trigger on enter not on keyup
            }
        },
        // {
        //     label: 'Period Start Date',
        //     field: 'start_date',
        //     filterable: true,
        //     fpFieldType:"text",
        //     hidden:true,
        //     filterOptions: {
        //         enabled: false, // enable filter for this column
        //         placeholder: "MM/DD/YYYY", // placeholder for filter input
        //         filterValue: '', // initial populated value for this filter
        //         trigger: "enter" //only trigger on enter not on keyup
        //     }
        // },
      ],
      action:'list',
      batchProcess:0,
      batchNum:"",

  }),
  watch:{
    permissions: function(permission) {
        var self = this;
        permission.forEach(function (permissions) {
            if(permissions.name == 'bill_reading_for_period_report') {
                self.cantAccessPage = true;
            }
        });
        if(self.cantAccessPage == ''){
            self.cantAccessPage = false;
        }
    },
  },
  mounted: function(){
    var self = this;
    self.getPermissions();
  },
  methods:{
        // exportReports: function() {
        //     var self = this;
        //     this.action = "export";
        //     this.loadList();
        // },
        cancelAll: function (cancelAll) {
            this.$refs.subDayPeriodTable.unselectAllInternal();
        },

    loadList: function(){

      var self = this;
      self.loading = true;
      var date = new Date();
      var offset = date.getTimezoneOffset();
      $.ajax({
        url: process.env.ROOT_API + "/billing-reading/list",
        type: "POST",
        crossDomain: true,
        headers: this.ajxHeaders,
        dataType: "json",
        data: {
          page: self.serverParams.page,
          perPage: self.serverParams.perPage,
          filters: this.serverParams.columnFilters,
          sort: this.serverParams.sort,
          offset: offset,
          action : self.action

        },
        success: function(data) {
          self.loading = false;
          //console.log(data.content[0]["id"]);
          if (data.status == "success") {
            if (self.action == "export" ||  self.action == "export_queue") {

                if ( data.code == "201" ) {
                    alert(data.message);
                } else {

                    if ( self.action == "export" ) {

                        self.excel = data.content.web;
                        var save = document.createElement("a");
                        save.href = self.excel;
                        save.download = data.content.web;
                        save.target = "_blank";

                        document.body.appendChild(save);
                        save.click();
                        document.body.removeChild(save);

                    } else {

                        self.batchProcess = 1;
                        self.batchNum = data.content;
                    }

                }

              self.action = "list";
              self.loadList();

            } else {
              if (data.content.row != undefined) {
                self.rows = data.content.row;
              }

              self.totalRecords = data.content.totalRecords;
            }


          }
        },
        error: function(jqXHR, exception) {
          self.loading = false;
            self.generateStatusCodeMessage(jqXHR,true,'reservation-list-booking')
        }
      });

    }

  }

}
</script>



// WEBPACK FOOTER //
// src/components/reports/BillingReadingForPeriod.vue